import { render } from "./drawNew.vue?vue&type=template&id=3035d35c&scoped=true"
import script from "./drawNew.vue?vue&type=script&lang=js"
export * from "./drawNew.vue?vue&type=script&lang=js"

import "./drawNew.vue?vue&type=style&index=0&id=3035d35c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3035d35c"]])

export default __exports__